import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;


export interface IMenuItem {
    text: string;
    icon?: string;
    type: 'bool' | 'text';
    onClick: (value?: boolean) => any;
    active?: boolean;
    class?: string
}

function BooleanSwitch({active, text, ref}: { active: boolean, text: string, ref: RefObject<HTMLInputElement> }) {
    return (
        // <div id="design-switch" className="design-switch">
        <>
            <span>{text}</span>
            <div className={active ? "switch small active" : 'small switch'} ref={ref}></div>
        </>
        // </div>
    )
}

function FallDownMenuItem(item: IMenuItem) {
    const switchElement: RefObject<HTMLInputElement> = {};
    return (
        <li className={"item" + (item.class ? ' ' + item.class : '')} onClick={function () {
            if (switchElement.value)
                $(switchElement.value).toggleClass('active');
            item.onClick.call(this, item.active = !item.active)
        }}>
            {!!item.icon && <i className={"fa fa-" + item.icon}/>}
            {item.type === 'bool' ? <BooleanSwitch active={item.active!} text={item.text} ref={switchElement}/> : item.text}
        </li>
    )
}

export function FallDownMenu({items, position, title}: { items: IMenuItem[], position: HTMLElement, title?: string }) {
    let offset = $(position).offset()!;
    const element: HTMLDivElement = (
        <div className="falldown-menu bordered" style={{
            top: offset.top + "px",
            left: offset.left + "px"
        }}>
            <ul>
                {title && <ul className="item no-select title">{title}</ul>}
                {
                    ...items.map(i => <FallDownMenuItem {...i}/>)
                }
            </ul>
        </div>
    );
    setTimeout(
        () => {
            $(document).on("click", onClick);
            $(window).on('resize', onResize)
        }
    );


    return element;

    function onClick(e: JQuery.ClickEvent) {
        if ($(e.target!).parents('.falldown-menu')[0]) return;
        setTimeout(() => {
            $(element).remove();
            $(document).off('click', onClick);
            $(window).off('resize', onResize)
        })
    }

    function onResize() {
        offset = $(position).offset()!
        element.style.top = offset.top + "px";
        element.style.left = offset.left + "px";
    }
}

export function createMenu(fallDownMenuItem: any) {
    if ($('.falldown-menu')[0]) return;
    document.body.appendChild(fallDownMenuItem);
}
